import { render, staticRenderFns } from "./CustomerPriceListTableExpansion.vue?vue&type=template&id=7b6593ca&scoped=true&"
import script from "./CustomerPriceListTableExpansion.vue?vue&type=script&lang=js&"
export * from "./CustomerPriceListTableExpansion.vue?vue&type=script&lang=js&"
import style0 from "./CustomerPriceListTableExpansion.vue?vue&type=style&index=0&id=7b6593ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6593ca",
  null
  
)

export default component.exports